import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import btnClose from '../../assets/svg/btn/close.svg'
import Slider from '@mui/material/Slider';
import axiosClient from '../../../axios-client';
import icCredit from '../../assets/svg/modal/ic-credits.svg'
import icBtn from '../../assets/svg/btn/next-btn.svg'


const BuyCredits = ({ show, handleClose }) => {
    const [sliderValue, setSliderValue] = useState();
    const [totalCost, setTotalCost] = useState(0);
    const [msgCredit, setMsgCredit] = useState();
    const [confirmMsgCredit, setMsgConfirmCredit] = useState();
    const [priceCredit, setPriceCredit] = useState();
    const [minByCredit, setMinByCredit] = useState();
    const [maxByCredit, setMaxByCredit] = useState();
    const [minCredit, setMinCredit] = useState();

    const [msgtError, setMsgError] = useState();

    useEffect(() => {
        fetchData();
    }, []);


    const updateCreditState = (data) => {
        const globalCredit = data.data;

        // console.log(globalCredit)

        const minBuyCredit = globalCredit.data.custom_credit.min_buy_credit == null ? globalCredit.min_buy_credit : globalCredit.data.custom_credit.min_buy_credit;
        const creditPrice = globalCredit.data.custom_credit.credit_price == null ? globalCredit.credit_price : globalCredit.data.custom_credit.credit_price;
        const minCredit = globalCredit.data.custom_credit.min_buy_credit == null ? globalCredit.min_buy_credit : globalCredit.data.custom_credit.min_buy_credit;
        const maxBuyCredit = globalCredit.data.custom_credit.max_buy_credit == null ? globalCredit.max_buy_credit : globalCredit.data.custom_credit.max_buy_credit;
        const msgCost = globalCredit.data.custom_credit.message_credit == null ? globalCredit.message_credit : globalCredit.data.custom_credit.message_credit;
        const confirmMsg = globalCredit.data.custom_credit.confirmation_credit == null ? globalCredit.confirmation_credit : globalCredit.data.custom_credit.confirmation_credit;

        setMsgCredit(msgCost);

        setSliderValue(minBuyCredit);
        setMsgConfirmCredit(confirmMsg);

        setPriceCredit(creditPrice);
        setMinByCredit(minBuyCredit);
        setMaxByCredit(maxBuyCredit);

        const calculatedTotalCost = minBuyCredit * creditPrice;
        setTotalCost(calculatedTotalCost);

        if (sliderValue > maxBuyCredit) {
            setSliderValue(maxBuyCredit);
            setTotalCost(maxBuyCredit * creditPrice);
        }

        setMinCredit(minBuyCredit);
    };

    const handleSliderChange = (event, newValue) => {
        setSliderValue(newValue);
        const cost = newValue * priceCredit;
        setTotalCost(cost);
    };

    const goToCheckout = async () => {
        try {
            const { data } = await axiosClient.post(`/payments?credit=${sliderValue}`);
            // console.log('Data received from API:', data);
            if (data.data.url) {
                window.location.href = data.data.url;
            } else {
                // console.error('Invalid payment URL:', data);
            }
        } catch (error) {
            // console.error('error:', error);
            if (error.response) {
                setMsgError(error.response.data.message);

                setTimeout(() => {
                    setMsgError(null);
                }, 4000);

                // console.error('Response data:', error.response.data);
                // console.error('Response status:', error.response.status);
                // console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                // console.error('Request data:', error.request);
            } else {
                // console.error('Error message:', error.message);
            }
        }
    };



    const fetchData = () => {
        Promise.all([axiosClient.get('/app-settings'), axiosClient.get('/user')])
            .then(([appSettingsData, userData]) => {
                // console.log(appSettingsData);
                // console.log(userData);

                // Use the necessary data from each API call
                const combinedData = {
                    data: {
                        ...appSettingsData.data.data,
                        ...userData.data,
                    },
                };

                updateCreditState(combinedData);
            })
            .catch((error) => {
                // console.error("An error occurred while fetching data:", error);
            });
    };



    return (
        <Modal centered className='modal-lg' show={show} onHide={handleClose}>
            <Modal.Header className='border-0 d-flex flex-row-reverse bd-highlight'>
                <Button className='rounded-circle btn-gray' variant='none' onClick={handleClose}>
                    <img src={btnClose} alt='' />
                </Button>
            </Modal.Header>
            <Modal.Body className='p-0'>
                <div className='container-fluid text-center'>
                    <img className='ic-modal' src={icCredit} alt='' srcSet='' />
                    <h3 className='text-center title my-3'>Choose your Credits</h3>
                </div>
                <p className='text-center'>
                    Every message you send will cost <span className='txt-green bolder'>{msgCredit} credit</span>
                </p>
                <div className='divider my-4'></div>
                <form className='row my-5 mx-4 justify-content-center align-items-center'>
                    <Slider
                        className='my-auto'
                        value={Number(sliderValue)}
                        min={Number(minCredit)}
                        step={100}
                        max={Number(maxByCredit)}
                        onChange={handleSliderChange}
                        valueLabelDisplay='auto'
                        aria-labelledby='non-linear-slider'
                        aria-label="Small"
                        valueLabelFormat={`${sliderValue} | ${totalCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}
                    />
                    <div className='mt-2 d-flex justify-content-between py-3'>
                        <p className='fw-bold'>{minByCredit} Credits</p>
                        <p className='fw-bold'>{maxByCredit} Credits</p>
                    </div>
                    <div className={`${!msgtError ? 'd-none' : 'd-block'} w-50 alert alert-danger my-2`} role="alert">
                        {msgtError}
                    </div>
                    <div className='my-1 d-flex justify-content-center justify-align-center'>

                        <span role='button' onClick={goToCheckout} className='d-flex align-items-center left-btn mx-2 my-2'>
                            <span className='btn-primary fw-bold py-1 text-start px-1 rounded-pill mx-1'>
                                <div className='d-flex align-items-center'>
                                    <span className='ps-3 pe-2'>
                                        {`Buy ${sliderValue} Credits for ${totalCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}
                                    </span>
                                    <img src={icBtn} alt='Buy Credits' />
                                </div>
                            </span>
                        </span>
                    </div>
                    {/* <div className='py-2 m-y'>
                        <p className='text-start'>
                            You have <span className='text-danger bolder'>XX unpaid</span> confirmations. Please recharge your account with at least <span className='txt-green bolder'>XXX credits</span> to be able to check these confirmations.
                        </p>
                    </div> */}
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default BuyCredits;
